import { post } from "./http";
const salePlanApi = {
    listPageBuyer: params => { return post(`/planDemandMonthBuyer/listPageBuyer`, params); },
    listBuyerPlanMonthSales: params =>{
        return post(`/planMothSalesBuyer/listBuyerPlanMonthSales`,params);
        },   //商品销售计划及执行列表
	getPlanMonthSalesAllDetail: params =>{return post(`/planMothSalesBuyer/getPlanMonthSalesAllDetail`,params);}  //商品销售计划详情
};

export default salePlanApi;